// extracted by mini-css-extract-plugin
module.exports = {"header":"ll","logo":"lm","navLink":"ln","linkButtonFrame":"lo","linkButton":"lp"};